var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',attrs,false),Object.assign(on, { click: _vm.doAppReload})),[_c('v-icon',{staticClass:"mx-2",attrs:{"small":""}},[_vm._v("mdi-autorenew")])],1)]}}])},[_c('div',[_vm._v(" Webapp-Version: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.versionDate)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }